import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

interface ColumnType {
  field: string;
  header: string;
}

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  standalone: false
})
export class DataTableComponent {

  @Input() columns: ColumnType[] = [];
  @Input() data: any[] = [];

  @ContentChild('rowTemplate', { read: TemplateRef })
  customRowTemplate?: TemplateRef<any>;

  constructor() { }
  
}
